import { consumablesUrl } from '../../urls';

export const orderConsumablesUrl = () => `${consumablesUrl()}/order`;

export const worksheetCarrierResponsesUrl = () => `${consumablesUrl()}/carrier-responses`;
